import { styled } from '@withjoy/joykit/theme';
import { ItemsWrapper } from '@withjoy/joykit/components/SegmentedController/SegmentedController.styles';

/** Full-width mobile tab row; centers SegmentedController items (mobile tabs left-align by default). */
export const MobileProductTabsRoot = styled.div`
  width: 100%;

  ${ItemsWrapper} {
    justify-content: center;
  }
`;
